import React, { useState, useEffect } from 'react';
import './filters.css';

export default function Filters({ filters, onChange, onApply }) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [sizeType, setSizeType] = useState('clothes');


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleGroup = (e) => {
    const group = e.currentTarget.closest('.filters-group');
    if (group) group.classList.toggle('expanded');
  };

  const closeOverlay = () => setShowOverlay(false);

  return (
    <>
      {isMobile && (
        <button className="filters-float-button" onClick={() => setShowOverlay(true)}>
          Show Filters
        </button>
      )}

      {!isMobile || showOverlay ? (
        <div className={`filters-container ${showOverlay ? 'overlay' : ''}`}>
          {isMobile && (
            <div className="filters-header">
              <h2 className="filters-title">Filters</h2>
              <button className="filters-close-btn" onClick={closeOverlay}>✕</button>
            </div>
          )}

          <div className="filters-group expanded">
            <button className="filters-dropdown-toggle" onClick={toggleGroup}>Type</button>
            <select
              className="filters-select"
              value={filters.typeOfProuct}
              onChange={(e) => onChange('typeOfProuct', e.target.value)}
            >
              <option value="">All</option>
              <option value="T-Shirt">T-Shirt</option>
              <option value="Jeans">Jeans</option>
              <option value="Hoodie">Hoodie</option>
              <option value="Shoes">Shoes</option>
            </select>
          </div>

          <div className="filters-group">
            <button className="filters-dropdown-toggle" onClick={toggleGroup}>Price</button>
            <div className="filters-range-wrapper">
              <input
                type="range"
                min="50"
                max="200"
                value={filters.price[0]}
                onChange={(e) => onChange('price', [Number(e.target.value), filters.price[1]])}
                className="filters-range"
              />
              <input
                type="range"
                min="50"
                max="1000"
                value={filters.price[1]}
                onChange={(e) => onChange('price', [filters.price[0], Number(e.target.value)])}
                className="filters-range"
              />
              <p className="filters-price">${filters.price[0]} - ${filters.price[1]}</p>
            </div>
          </div>

          <div className="filters-group expanded">
            <button className="filters-dropdown-toggle" onClick={toggleGroup}>Color</button>
            <div className="filters-color-options">
              {["green", "red", "blue", "yellow", "black", "purple", "lightblue", "lightgreen", "pink", "orange"].map((color) => (
                <button
                  key={color}
                  className={`filters-color ${filters.color === color ? "selected" : ""}`}
                  style={{ backgroundColor: color }}
                  onClick={() => onChange('color', color)}
                />
              ))}
            </div>
          </div>

          {/* <div className="filters-group expanded">
            <button className="filters-dropdown-toggle" onClick={toggleGroup}>Size</button>
            <div className="filters-size-options">
              {["XS", "S", "M", "L", "XL"].map((size) => (
                <button
                  key={size}
                  className={`filters-size ${filters.size === size ? "selected" : ""}`}
                  onClick={() => onChange('size', size)}
                >
                  {size}
                </button>
              ))}
            </div>
          </div> */}

          <div className="filters-group expanded">
            <button className="filters-dropdown-toggle" onClick={toggleGroup}>Size</button>

            <div className="filters-size-options">
              <button
                className={`filters-size ${sizeType === 'clothes' ? 'selected' : ''}`}
                onClick={() => setSizeType('clothes')}
              >
                Clothes
              </button>
              <button
                className={`filters-size ${sizeType === 'shoes' ? 'selected' : ''}`}
                onClick={() => setSizeType('shoes')}
              >
                Shoes
              </button>
            </div>

            <div className="filters-size-options">
              {sizeType === 'clothes' &&
                ["XS", "S", "M", "L", "XL"].map((size) => (
                  <button
                    key={size}
                    className={`filters-size ${filters.size === size ? "selected" : ""}`}
                    onClick={() => onChange('size', size)}
                  >
                    {size}
                  </button>
                ))
              }
              {sizeType === 'shoes' &&
                ["40", "41", "42", "43", "44"].map((size) => (
                  <button
                    key={size}
                    className={`filters-size ${filters.size === size ? "selected" : ""}`}
                    onClick={() => onChange('size', size)}
                  >
                    {size}
                  </button>
                ))
              }
            </div>
          </div>


          <div className="filters-group expanded">
            <button className="filters-dropdown-toggle" onClick={toggleGroup}>Category</button>
            <select
              className="filters-select"
              value={filters.category}
              onChange={(e) => onChange('category', e.target.value)}
            >
              <option value="">All</option>
              <option value="Casual">Casual</option>
              <option value="Formal">Formal</option>
              <option value="Party">Party</option>
              <option value="Gym">Gym</option>
            </select>
          </div>

          <button
            onClick={() => {
              onApply();
              if (isMobile) closeOverlay();
            }}
            className="filters-apply-button"
          >
            Apply Filter
          </button>
        </div>
      ) : null}
    </>
  );
}
